"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Do not edit directly
 */

const colors = {
  background: {
    elevation: {
      sunken: 'hsla(0, 0%, 66%, 0.1)',
      flat: 'hsl(0, 0%, 100%)',
      raised: 'hsl(0, 0%, 100%)',
      floating: 'hsl(0, 0%, 100%)'
    },
    primary: {
      opaque: 'hsl(0, 0%, 100%)',
      translucent: 'hsla(0, 0%, 100%, 0.85)',
      transparent: 'hsla(0, 0%, 100%, 0.2)'
    },
    secondary: {
      opaque: 'hsl(0, 0%, 96%)',
      translucent: 'hsla(0, 0%, 96%, 0.85)',
      transparent: 'hsla(0, 0%, 66%, 0.1)'
    },
    tertiary: {
      opaque: 'hsl(0, 0%, 91%)',
      translucent: 'hsla(0, 0%, 91%, 0.85)',
      transparent: 'hsla(0, 0%, 42%, 0.1)'
    },
    informative: {
      opaque: 'hsl(194, 100%, 92%)',
      translucent: 'hsla(194, 100%, 92%, 0.85)',
      transparent: 'hsla(203, 100%, 59%, 0.1)'
    },
    positive: {
      opaque: 'hsl(139, 90%, 90%)',
      translucent: 'hsla(139, 90%, 90%, 0.85)',
      transparent: 'hsla(149, 94%, 50%, 0.1)'
    },
    negative: {
      opaque: 'hsl(5, 100%, 93%)',
      translucent: 'hsla(5, 100%, 93%, 0.85)',
      transparent: 'hsla(358, 100%, 68%, 0.1)'
    },
    notice: {
      opaque: 'hsl(34, 100%, 87%)',
      translucent: 'hsla(34, 100%, 87%, 0.85)',
      transparent: 'hsla(36, 100%, 56%, 0.1)'
    },
    special: {
      opaque: 'hsl(48, 100%, 86%)',
      translucent: 'hsla(48, 100%, 86%, 0.85)',
      transparent: 'hsla(45, 100%, 50%, 0.1)'
    }
  },
  illustrations: {
    blue: 'hsl(206, 84%, 43%)',
    darkBlue: 'hsl(205, 81%, 21%)',
    green: 'hsl(144, 53%, 59%)',
    darkGreen: 'hsl(144, 37%, 50%)',
    yellow: 'hsl(40, 97%, 54%)',
    orange: 'hsl(32, 88%, 54%)'
  },
  metal: {
    bronze: {
      '50': 'hsl(33, 60%, 95%)',
      '200': 'hsl(28, 32%, 85%)',
      '400': 'hsl(27, 25%, 61%)',
      '600': 'hsl(25, 25%, 44%)',
      '700': 'hsl(24, 29%, 30%)'
    },
    silver: {
      '50': 'hsl(202, 100%, 95%)',
      '200': 'hsl(203, 100%, 91%)',
      '400': 'hsl(205, 29%, 66%)',
      '600': 'hsl(206, 32%, 39%)',
      '700': 'hsl(206, 48%, 24%)'
    },
    gold: {
      '50': 'hsl(44, 35%, 95%)',
      '200': 'hsl(42, 32%, 86%)',
      '400': 'hsl(37, 25%, 62%)',
      '600': 'hsl(34, 25%, 41%)',
      '700': 'hsl(35, 28%, 30%)'
    },
    platinum: {
      '50': 'hsl(191, 100%, 97%)',
      '200': 'hsl(194, 100%, 92%)',
      '400': 'hsl(205, 29%, 66%)',
      '600': 'hsl(206, 32%, 39%)',
      '700': 'hsl(206, 48%, 24%)'
    }
  },
  shadow: {
    opaque: 'hsl(0, 0%, 27%)',
    light: 'hsla(0, 0%, 27%, 0.1)',
    bold: 'hsla(0, 0%, 27%, 0.2)',
    heavy: 'hsla(0, 0%, 27%, 0.5)'
  },
  accent: {
    primary: {
      '200': 'hsl(95, 51%, 85%)',
      '400': 'hsl(95, 43%, 55%)',
      '500': 'hsl(95, 50%, 44%)',
      '600': 'hsl(95, 61%, 29%)'
    },
    secondary: {
      '200': 'hsl(205, 100%, 81%)',
      '400': 'hsl(208, 77%, 52%)',
      '500': 'hsl(207, 98%, 40%)',
      '600': 'hsl(208, 100%, 32%)'
    },
    tertiary: {
      '200': 'hsl(11, 100%, 86%)',
      '400': 'hsl(8, 84%, 61%)',
      '500': 'hsl(8, 78%, 55%)',
      '600': 'hsl(8, 66%, 50%)'
    }
  },
  border: {
    primary: {
      opaque: 'hsl(0, 0%, 91%)',
      translucent: 'hsla(0, 0%, 91%, 0.85)',
      transparent: 'hsla(0, 0%, 66%, 0.2)'
    },
    secondary: {
      opaque: 'hsl(0, 0%, 85%)',
      translucent: 'hsla(0, 0%, 85%, 0.85)',
      transparent: 'hsla(0, 0%, 57%, 0.2)'
    },
    tertiary: {
      opaque: 'hsl(0, 0%, 74%)',
      translucent: 'hsla(0, 0%, 85%, 0.85)',
      transparent: 'hsla(0, 0%, 42%, 0.2)'
    },
    informative: {
      opaque: 'hsl(196, 100%, 82%)',
      translucent: 'hsla(196, 100%, 82%, 0.85)',
      transparent: 'hsla(203, 100%, 59%, 0.2)'
    },
    positive: {
      opaque: 'hsl(141, 84%, 81%)',
      translucent: 'hsla(141, 84%, 81%, 0.85)',
      transparent: 'hsla(149, 94%, 50%, 0.2)'
    },
    negative: {
      opaque: 'hsl(2, 100%, 88%)',
      translucent: 'hsla(2, 100%, 88%, 0.85)',
      transparent: 'hsla(356, 97%, 58%, 0.2)'
    },
    notice: {
      opaque: 'hsl(32, 100%, 79%)',
      translucent: 'hsla(32, 100%, 79%, 0.85)',
      transparent: 'hsla(36, 100%, 56%, 0.2)'
    },
    special: {
      opaque: 'hsl(49, 96%, 76%)',
      translucent: 'hsla(49, 96%, 76%, 0.85)',
      transparent: 'hsla(46, 98%, 57%, 0.2)'
    }
  },
  icon: {
    primary: {
      opaque: 'hsl(0, 0%, 57%)'
    },
    secondary: {
      opaque: 'hsl(0, 0%, 74%)'
    },
    informative: {
      opaque: 'hsl(207, 98%, 40%)'
    },
    positive: {
      opaque: 'hsl(147, 71%, 49%)'
    },
    negative: {
      opaque: 'hsl(356, 97%, 58%)'
    },
    notice: {
      opaque: 'hsl(26, 100%, 55%)'
    },
    special: {
      opaque: 'hsl(45, 100%, 50%)'
    }
  },
  inverseBackground: {
    primary: {
      opaque: 'hsl(0, 0%, 19%)'
    },
    secondary: {
      opaque: 'hsl(0, 0%, 27%)'
    },
    tertiary: {
      opaque: 'hsl(0, 0%, 42%)'
    },
    informative: {
      opaque: 'hsl(207, 98%, 40%)'
    },
    positive: {
      opaque: 'hsl(147, 71%, 49%)'
    },
    negative: {
      opaque: 'hsl(356, 97%, 58%)'
    },
    notice: {
      opaque: 'hsl(26, 100%, 55%)'
    },
    special: {
      opaque: 'hsl(45, 100%, 50%)'
    }
  },
  inverseBorder: {
    primary: {
      opaque: 'hsl(0, 0%, 27%)'
    },
    secondary: {
      opaque: 'hsl(0, 0%, 42%)'
    },
    tertiary: {
      opaque: 'hsl(0, 0%, 57%)'
    },
    informative: {
      opaque: 'hsl(208, 100%, 32%)'
    },
    positive: {
      opaque: 'hsl(149, 74%, 40%)'
    },
    negative: {
      opaque: 'hsl(354, 78%, 47%)'
    },
    notice: {
      opaque: 'hsl(24, 89%, 45%)'
    },
    special: {
      opaque: 'hsl(40, 100%, 43%)'
    }
  },
  neutral: {
    '0': 'hsl(0, 0%, 100%)',
    '50': 'hsl(0, 0%, 96%)',
    '100': 'hsl(0, 0%, 91%)',
    '200': 'hsl(0, 0%, 85%)',
    '300': 'hsl(0, 0%, 74%)',
    '400': 'hsl(0, 0%, 66%)',
    '500': 'hsl(0, 0%, 57%)',
    '600': 'hsl(0, 0%, 42%)',
    '700': 'hsl(0, 0%, 27%)',
    '800': 'hsl(0, 0%, 19%)',
    '900': 'hsl(0, 0%, 12%)',
    '1000': 'hsl(0, 0%, 0%)'
  },
  text: {
    primary: {
      opaque: 'hsl(0, 0%, 27%)',
      translucent: 'hsla(0, 0%, 27%, 0.85)',
      transparent: 'hsla(0, 0%, 19%, 0.7)'
    },
    secondary: {
      opaque: 'hsl(0, 0%, 42%)',
      translucent: 'hsla(0, 0%, 42%, 0.85)',
      transparent: 'hsla(0, 0%, 27%, 0.7)'
    },
    tertiary: {
      opaque: 'hsl(0, 0%, 57%)',
      translucent: 'hsla(0, 0%, 57%, 0.85)',
      transparent: 'hsla(0, 0%, 42%, 0.7)'
    },
    quaternary: {
      opaque: 'hsl(0, 0%, 66%)',
      translucent: 'hsla(0, 0%, 66%, 0.85)',
      transparent: 'hsla(0, 0%, 57%, 0.7)'
    },
    informative: {
      opaque: 'hsl(206, 48%, 24%)',
      translucent: 'hsla(210, 100%, 25%, 0.85)',
      transparent: 'hsla(210, 100%, 25%, 0.7)'
    },
    positive: {
      opaque: 'hsl(162, 25%, 20%)',
      translucent: 'hsla(153, 90%, 20%, 0.85)',
      transparent: 'hsla(156, 94%, 12%, 0.7)'
    },
    negative: {
      opaque: 'hsl(349, 21%, 21%)',
      translucent: 'hsla(350, 96%, 28%, 0.85)',
      transparent: 'hsla(348, 98%, 20%, 0.7)'
    },
    notice: {
      opaque: 'hsl(28, 25%, 19%)',
      translucent: 'hsla(20, 100%, 27%, 0.85)',
      transparent: 'hsla(18, 100%, 20%, 0.7)'
    },
    special: {
      opaque: 'hsl(37, 26%, 20%)',
      translucent: 'hsla(33, 100%, 20%, 0.85)',
      transparent: 'hsla(33, 100%, 20%, 0.7)'
    },
    link: {
      opaque: 'hsl(207, 98%, 40%)',
      translucent: 'hsla(213, 94%, 49%, 0.85)',
      transparent: 'hsla(213, 94%, 49%, 0.7)'
    },
    overBackground: {
      opaque: 'hsl(0, 0%, 100%)',
      translucent: 'hsla(0, 0%, 100%, 0.85)',
      transparent: 'hsla(0, 0%, 100%, 0.7)'
    }
  },
  component: {
    alert: {
      negative: {
        background: 'hsla(358, 100%, 68%, 0.1)',
        text: 'hsl(349, 21%, 21%)',
        icon: 'hsl(356, 97%, 58%)',
        action: 'hsl(349, 21%, 21%)'
      },
      informative: {
        background: 'hsla(203, 100%, 59%, 0.1)',
        text: 'hsl(206, 48%, 24%)',
        icon: 'hsl(207, 98%, 40%)',
        action: 'hsl(206, 48%, 24%)'
      },
      positive: {
        background: 'hsla(149, 94%, 50%, 0.1)',
        text: 'hsl(162, 25%, 20%)',
        icon: 'hsl(147, 71%, 49%)',
        action: 'hsl(162, 25%, 20%)'
      },
      notice: {
        background: 'hsla(36, 100%, 56%, 0.1)',
        text: 'hsl(28, 25%, 19%)',
        icon: 'hsl(26, 100%, 55%)',
        action: 'hsl(28, 25%, 19%)'
      }
    },
    button: {
      primary: {
        contained: {
          normal: {
            background: 'hsl(95, 50%, 44%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(95, 51%, 85%)'
          },
          hover: {
            background: 'hsl(95, 43%, 55%)'
          },
          active: {
            background: 'hsl(95, 61%, 29%)'
          }
        },
        text: {
          normal: {
            text: 'hsl(95, 50%, 44%)',
            icon: 'hsl(95, 43%, 55%)'
          },
          hover: {
            background: 'hsla(203, 100%, 59%, 0.1)'
          },
          active: {
            background: 'hsla(95, 61%, 29%, 0.1)',
            text: 'hsl(95, 61%, 29%)',
            icon: 'hsl(95, 50%, 44%)'
          }
        }
      },
      secondary: {
        contained: {
          normal: {
            background: 'hsla(95, 43%, 55%, 0.1)',
            text: 'hsl(95, 50%, 44%)',
            icon: 'hsl(95, 43%, 55%)'
          },
          hover: {
            background: 'hsla(95, 43%, 55%, 0.2)'
          },
          active: {
            background: 'hsla(95, 61%, 29%, 0.1)',
            text: 'hsl(95, 61%, 29%)',
            icon: 'hsl(95, 50%, 44%)'
          }
        },
        text: {
          normal: {
            text: 'hsl(207, 98%, 40%)',
            icon: 'hsl(207, 98%, 40%)'
          },
          hover: {
            background: 'hsla(203, 100%, 59%, 0.1)'
          },
          active: {
            background: 'hsla(95, 61%, 29%, 0.1)',
            text: 'hsl(95, 61%, 29%)',
            icon: 'hsl(95, 50%, 44%)'
          }
        }
      },
      tertiary: {
        contained: {
          normal: {
            background: 'hsla(0, 0%, 66%, 0.1)',
            text: 'hsl(0, 0%, 27%)',
            icon: 'hsl(0, 0%, 57%)'
          },
          hover: {
            background: 'hsla(0, 0%, 57%, 0.2)'
          },
          active: {
            background: 'hsla(0, 0%, 57%, 0.5)'
          }
        },
        text: {
          normal: {
            text: 'hsl(0, 0%, 27%)',
            icon: 'hsl(0, 0%, 57%)'
          },
          hover: {
            background: 'hsla(0, 0%, 66%, 0.1)'
          },
          active: {
            background: 'hsla(0, 0%, 57%, 0.2)'
          }
        }
      },
      accent: {
        contained: {
          normal: {
            background: 'hsl(8, 78%, 55%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(11, 100%, 86%)'
          },
          hover: {
            background: 'hsl(8, 84%, 61%)'
          },
          active: {
            background: 'hsl(8, 66%, 50%)'
          }
        },
        text: {
          normal: {
            text: 'hsl(8, 78%, 55%)',
            icon: 'hsl(8, 84%, 61%)'
          },
          hover: {
            background: 'hsla(8, 84%, 61%, 0.1)'
          },
          active: {
            background: 'hsla(8, 66%, 50%, 0.1)',
            text: 'hsl(8, 66%, 50%)',
            icon: 'hsl(8, 78%, 55%)'
          }
        }
      },
      facebook: {
        contained: {
          normal: {
            background: 'hsl(214, 89%, 52%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          hover: {
            background: 'hsl(214, 90%, 49%)'
          },
          active: {
            background: 'hsl(210, 100%, 58%)'
          }
        }
      },
      apple: {
        contained: {
          normal: {
            background: 'hsl(0, 0%, 0%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          hover: {
            background: 'hsl(0, 0%, 20%)'
          },
          active: {
            background: 'hsl(0, 0%, 27%)'
          }
        }
      },
      google: {
        contained: {
          normal: {
            background: 'hsl(200, 28%, 96%)',
            text: 'hsl(206, 48%, 24%)'
          },
          hover: {
            background: 'hsl(201, 28%, 92%)'
          },
          active: {
            background: 'hsl(204, 26%, 86%)'
          }
        }
      }
    },
    card: {
      header: {
        borderColor: 'hsla(0, 0%, 66%, 0.2)'
      },
      footer: {
        borderColor: 'hsla(0, 0%, 66%, 0.2)'
      }
    },
    chip: {
      blue: {
        default: {
          normal: {
            background: 'hsl(207, 98%, 40%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(205, 100%, 81%)'
          },
          hover: {
            background: 'hsl(208, 77%, 52%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(208, 100%, 32%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(206, 48%, 24%)',
            icon: 'hsl(206, 100%, 51%)',
            border: 'hsl(203, 100%, 59%)'
          },
          hover: {
            text: 'hsl(207, 98%, 40%)',
            icon: 'hsl(206, 100%, 51%)',
            border: 'hsl(200, 100%, 67%)'
          },
          active: {
            border: 'hsl(206, 100%, 51%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(203, 100%, 59%, 0.1)',
            text: 'hsl(206, 48%, 24%)',
            icon: 'hsl(206, 100%, 51%)'
          },
          hover: {
            text: 'hsl(207, 98%, 40%)',
            icon: 'hsl(206, 100%, 51%)'
          },
          active: {
            background: 'hsla(203, 100%, 59%, 0.2)'
          }
        }
      },
      coral: {
        default: {
          normal: {
            background: 'hsl(5, 100%, 62%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(11, 100%, 86%)'
          },
          hover: {
            background: 'hsl(7, 100%, 71%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(3, 70%, 51%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(4, 23%, 28%)',
            icon: 'hsl(5, 100%, 62%)',
            border: 'hsl(7, 100%, 71%)'
          },
          hover: {
            text: 'hsl(5, 100%, 62%)',
            icon: 'hsl(5, 100%, 62%)',
            border: 'hsl(9, 100%, 78%)'
          },
          active: {
            border: 'hsl(5, 100%, 62%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(0, 100%, 60%, 0.1)',
            text: 'hsl(4, 23%, 28%)',
            icon: 'hsl(5, 100%, 62%)'
          },
          hover: {
            text: 'hsl(5, 100%, 62%)',
            icon: 'hsl(5, 100%, 62%)'
          },
          active: {
            background: 'hsla(0, 100%, 60%, 0.2)'
          }
        }
      },
      green: {
        default: {
          normal: {
            background: 'hsl(147, 71%, 49%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(141, 84%, 81%)'
          },
          hover: {
            background: 'hsl(145, 72%, 57%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(149, 74%, 40%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(160, 29%, 31%)',
            icon: 'hsl(147, 71%, 49%)',
            border: 'hsl(145, 72%, 57%)'
          },
          hover: {
            text: 'hsl(147, 71%, 49%)',
            icon: 'hsl(147, 71%, 49%)',
            border: 'hsl(143, 78%, 68%)'
          },
          active: {
            border: 'hsl(147, 71%, 49%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(149, 94%, 50%, 0.1)',
            text: 'hsl(160, 29%, 31%)',
            icon: 'hsl(147, 71%, 49%)'
          },
          hover: {
            text: 'hsl(147, 71%, 49%)',
            icon: 'hsl(147, 71%, 49%)'
          },
          active: {
            background: 'hsla(149, 94%, 50%, 0.2)'
          }
        }
      },
      inverseNeutral: {
        default: {
          normal: {
            background: 'hsl(0, 0%, 100%)',
            text: 'hsl(0, 0%, 27%)',
            icon: 'hsl(0, 0%, 57%)'
          },
          hover: {
            text: 'hsl(0, 0%, 42%)'
          },
          active: {
            text: 'hsl(0, 0%, 57%)',
            icon: 'hsl(0, 0%, 74%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 74%)',
            border: 'hsla(0, 0%, 66%, 0.2)'
          },
          hover: {
            border: 'hsla(0, 0%, 91%, 0.85)'
          },
          active: {
            background: 'hsla(0, 0%, 66%, 0.1)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(0, 0%, 100%, 0.2)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 74%)'
          },
          hover: {
            background: 'hsla(0, 0%, 66%, 0.1)'
          },
          active: {
            background: 'hsla(0, 0%, 42%, 0.1)',
            text: 'hsla(0, 0%, 100%, 0.7)'
          }
        }
      },
      neutral: {
        default: {
          normal: {
            background: 'hsl(0, 0%, 27%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 57%)'
          },
          hover: {
            background: 'hsl(0, 0%, 42%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(0, 0%, 19%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(0, 0%, 27%)',
            icon: 'hsl(0, 0%, 57%)',
            border: 'hsla(0, 0%, 42%, 0.2)'
          },
          hover: {
            text: 'hsl(0, 0%, 42%)',
            border: 'hsla(0, 0%, 85%, 0.85)'
          },
          active: {
            border: 'hsl(0, 0%, 74%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(0, 0%, 66%, 0.1)',
            text: 'hsl(0, 0%, 27%)',
            icon: 'hsl(0, 0%, 57%)'
          },
          hover: {
            background: 'hsla(0, 0%, 42%, 0.1)'
          },
          active: {
            background: 'hsla(203, 100%, 59%, 0.1)'
          }
        }
      },
      orange: {
        default: {
          normal: {
            background: 'hsl(26, 100%, 55%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(32, 100%, 79%)'
          },
          hover: {
            background: 'hsl(28, 100%, 64%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(24, 89%, 45%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(24, 29%, 30%)',
            icon: 'hsl(26, 100%, 55%)',
            border: 'hsl(28, 100%, 64%)'
          },
          hover: {
            text: 'hsl(26, 100%, 55%)',
            icon: 'hsl(26, 100%, 55%)',
            border: 'hsl(30, 100%, 72%)'
          },
          active: {
            border: 'hsl(26, 100%, 55%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(36, 100%, 56%, 0.1)',
            text: 'hsl(24, 29%, 30%)',
            icon: 'hsl(26, 100%, 55%)'
          },
          hover: {
            text: 'hsl(26, 100%, 55%)',
            icon: 'hsl(26, 100%, 55%)'
          },
          active: {
            background: 'hsla(26, 100%, 55%, 0.2)'
          }
        }
      },
      red: {
        default: {
          normal: {
            background: 'hsl(356, 97%, 58%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(2, 100%, 88%)'
          },
          hover: {
            background: 'hsl(358, 100%, 68%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(354, 78%, 47%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(356, 21%, 28%)',
            icon: 'hsl(356, 97%, 58%)',
            border: 'hsl(358, 100%, 68%)'
          },
          hover: {
            text: 'hsl(356, 97%, 58%)',
            icon: 'hsl(356, 97%, 58%)',
            border: 'hsl(0, 100%, 79%)'
          },
          active: {
            border: 'hsl(356, 97%, 58%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(358, 100%, 68%, 0.1)',
            text: 'hsl(356, 21%, 28%)',
            icon: 'hsl(356, 97%, 58%)'
          },
          hover: {
            text: 'hsl(356, 97%, 58%)',
            icon: 'hsl(356, 97%, 58%)'
          },
          active: {
            background: 'hsla(358, 100%, 68%, 0.2)'
          }
        }
      },
      teal: {
        default: {
          normal: {
            background: 'hsl(185, 83%, 39%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(179, 59%, 78%)'
          },
          hover: {
            background: 'hsl(183, 60%, 48%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(187, 92%, 30%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(190, 37%, 25%)',
            icon: 'hsl(185, 83%, 39%)',
            border: 'hsl(183, 60%, 48%)'
          },
          hover: {
            text: 'hsl(185, 83%, 39%)',
            icon: 'hsl(185, 83%, 39%)',
            border: 'hsl(181, 57%, 58%)'
          },
          active: {
            border: 'hsl(185, 83%, 39%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(183, 60%, 48%, 0.1)',
            text: 'hsl(190, 37%, 25%)',
            icon: 'hsl(185, 83%, 39%)'
          },
          hover: {
            text: 'hsl(185, 83%, 39%)',
            icon: 'hsl(185, 83%, 39%)'
          },
          active: {
            background: 'hsla(183, 60%, 48%, 0.2)'
          }
        }
      },
      yellow: {
        default: {
          normal: {
            background: 'hsl(45, 100%, 50%)',
            text: 'hsl(33, 100%, 20%)',
            icon: 'hsl(37, 100%, 35%)'
          },
          hover: {
            background: 'hsl(46, 94%, 69%)',
            text: 'hsl(33, 100%, 20%)',
            icon: 'hsl(40, 100%, 43%)'
          },
          active: {
            background: 'hsl(40, 100%, 43%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(35, 28%, 30%)',
            icon: 'hsl(40, 100%, 43%)',
            border: 'hsl(46, 98%, 57%)'
          },
          hover: {
            text: 'hsl(40, 100%, 43%)',
            icon: 'hsl(40, 100%, 43%)',
            border: 'hsl(46, 94%, 69%)'
          },
          active: {
            border: 'hsl(45, 100%, 50%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(48, 100%, 86%, 0.5)',
            text: 'hsl(35, 28%, 30%)',
            icon: 'hsl(40, 100%, 43%)'
          },
          hover: {
            text: 'hsl(40, 100%, 43%)',
            icon: 'hsl(40, 100%, 43%)'
          },
          active: {
            background: 'hsla(45, 100%, 50%, 0.2)'
          }
        }
      },
      primary: {
        default: {
          normal: {
            background: 'hsl(8, 78%, 55%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(11, 100%, 86%)'
          },
          hover: {
            background: 'hsl(8, 84%, 61%)',
            text: 'hsl(0, 0%, 100%)',
            icon: 'hsl(0, 0%, 100%)'
          },
          active: {
            background: 'hsl(8, 66%, 50%)'
          }
        },
        outlined: {
          normal: {
            text: 'hsl(8, 24%, 18%)',
            icon: 'hsl(8, 78%, 55%)',
            border: 'hsl(8, 84%, 61%)'
          },
          hover: {
            text: 'hsl(8, 78%, 55%)',
            icon: 'hsl(8, 78%, 55%)',
            border: 'hsl(8, 84%, 61%)'
          },
          active: {
            border: 'hsl(8, 66%, 50%)'
          }
        },
        subtle: {
          normal: {
            background: 'hsla(8, 84%, 61%, 0.1)',
            text: 'hsl(8, 24%, 18%)',
            icon: 'hsl(8, 78%, 55%)'
          },
          hover: {
            text: 'hsl(8, 66%, 50%)',
            icon: 'hsl(8, 84%, 61%)'
          },
          active: {
            background: 'hsla(8, 84%, 61%, 0.2)'
          }
        }
      }
    },
    divider: {
      background: 'hsla(0, 0%, 66%, 0.2)'
    },
    loyaltyProgramStatusProgress: {
      tickets: {
        background: 'hsla(45, 100%, 50%, 0.1)',
        progressTrack: 'hsl(48, 100%, 86%)',
        progressBar: 'hsl(45, 100%, 50%)',
        textLight: 'hsl(34, 25%, 41%)',
        textDark: 'hsl(37, 26%, 20%)'
      },
      distance: {
        background: 'hsla(149, 94%, 50%, 0.1)',
        progressTrack: 'hsl(139, 90%, 90%)',
        progressBar: 'hsl(147, 71%, 49%)',
        textLight: 'hsl(158, 25%, 41%)',
        textDark: 'hsl(162, 25%, 20%)'
      },
      countries: {
        background: 'hsla(203, 100%, 59%, 0.1)',
        progressTrack: 'hsl(203, 100%, 91%)',
        progressBar: 'hsl(207, 98%, 40%)',
        textLight: 'hsl(205, 25%, 53%)',
        textDark: 'hsl(206, 48%, 24%)'
      }
    },
    rewardsProgram: {
      bronze: {
        text: {
          primary: 'hsl(24, 29%, 30%)',
          secondary: 'hsl(25, 25%, 44%)'
        },
        background: 'hsl(33, 60%, 95%)',
        border: 'hsl(27, 25%, 61%)'
      },
      silver: {
        text: {
          primary: 'hsl(206, 48%, 24%)',
          secondary: 'hsl(206, 32%, 39%)'
        },
        background: 'hsl(202, 100%, 95%)',
        border: 'hsl(205, 29%, 66%)'
      },
      gold: {
        text: {
          primary: 'hsl(35, 28%, 30%)',
          secondary: 'hsl(34, 25%, 41%)'
        },
        background: 'hsl(44, 35%, 95%)',
        border: 'hsl(37, 25%, 62%)'
      },
      platinum: {
        text: {
          primary: 'hsl(206, 48%, 24%)',
          secondary: 'hsl(206, 32%, 39%)'
        },
        background: 'hsl(191, 100%, 97%)',
        border: 'hsl(205, 29%, 66%)'
      }
    },
    skeleton: {
      gradientFrom: 'hsl(0, 0%, 96%)',
      gradientTo: 'hsl(0, 0%, 91%)'
    },
    switch: {
      active: {
        primary: {
          foreground: 'hsl(95, 50%, 44%)',
          background: 'hsla(194, 100%, 92%, 0.85)'
        },
        secondary: {
          foreground: 'hsl(147, 71%, 49%)',
          background: 'hsla(139, 90%, 90%, 0.85)'
        }
      },
      inactive: {
        foreground: 'hsl(0, 0%, 100%)',
        background: 'hsla(0, 0%, 42%, 0.1)'
      },
      disabled: {
        foreground: 'hsl(0, 0%, 74%)',
        background: 'hsla(0, 0%, 91%, 0.85)'
      }
    },
    textfield: {
      normal: {
        background: 'hsl(0, 0%, 96%)',
        border: 'hsl(0, 0%, 96%)',
        icon: 'hsl(0, 0%, 57%)',
        label: 'hsl(0, 0%, 42%)',
        outline: 'hsla(203, 100%, 59%, 0.2)',
        placeholder: 'hsl(0, 0%, 66%)',
        text: 'hsl(0, 0%, 27%)'
      },
      disabled: {
        icon: 'hsl(0, 0%, 74%)',
        label: 'hsl(0, 0%, 66%)',
        placeholder: 'hsla(0, 0%, 66%, 0.7)',
        text: 'hsl(0, 0%, 66%)'
      },
      hover: {
        background: 'hsl(0, 0%, 100%)',
        border: 'hsl(0, 0%, 85%)'
      },
      focused: {
        background: 'hsl(0, 0%, 100%)',
        border: 'hsl(95, 43%, 55%)',
        icon: 'hsl(207, 98%, 40%)',
        label: 'hsl(95, 50%, 44%)'
      },
      focusedHover: {
        border: 'hsl(206, 100%, 51%)'
      },
      error: {
        background: 'hsla(358, 100%, 68%, 0.1)',
        border: 'hsl(354, 78%, 47%)',
        icon: 'hsl(356, 97%, 58%)',
        label: 'hsl(356, 97%, 58%)',
        text: 'hsl(349, 21%, 21%)'
      },
      errorHover: {
        background: 'hsl(0, 0%, 100%)'
      },
      errorFocused: {
        background: 'hsl(0, 0%, 100%)',
        outline: 'hsla(356, 97%, 58%, 0.2)'
      }
    },
    link: {
      normal: {
        text: 'hsl(207, 98%, 40%)'
      },
      hover: {
        text: 'hsl(208, 77%, 52%)'
      },
      active: {
        text: 'hsl(208, 100%, 32%)'
      }
    },
    backdrop: 'hsla(0, 0%, 91%, 0.7)',
    barChart: {
      backColumn: {
        neutral: {
          background: 'hsl(0, 0%, 96%)'
        },
        default: {
          background: 'hsla(194, 100%, 92%, 0.85)'
        }
      },
      frontColumn: {
        neutral: {
          background: 'hsl(0, 0%, 66%)'
        },
        default: {
          background: 'hsl(207, 98%, 40%)'
        }
      }
    },
    calendar: {
      date: {
        normal: {
          text: 'hsl(0, 0%, 27%)'
        },
        active: {
          background: 'hsl(95, 50%, 44%)',
          text: 'hsl(0, 0%, 100%)'
        },
        hover: {
          background: 'hsla(95, 51%, 85%, 0.5)',
          text: 'hsl(0, 0%, 27%)'
        },
        disabled: {
          text: 'hsl(0, 0%, 27%)'
        },
        weekend: {
          background: 'hsl(0, 0%, 96%)'
        },
        closeIcon: {
          background: 'hsl(0, 0%, 100%)',
          border: 'hsl(95, 50%, 44%)',
          icon: 'hsl(95, 50%, 44%)'
        }
      },
      selector: {
        normal: 'hsl(0, 0%, 57%)',
        hover: 'hsl(95, 50%, 44%)',
        disabled: 'hsl(0, 0%, 27%)'
      }
    },
    filters: {
      eTicketOnly: {
        icon: 'hsl(147, 71%, 49%)'
      },
      directOnly: {
        icon: 'hsl(45, 100%, 50%)'
      },
      departureTimeNighttime: {
        icon: 'hsl(254, 70%, 62%)'
      },
      departureTimeEarly: {
        icon: 'hsl(45, 100%, 50%)'
      },
      departureTimeMidday: {
        icon: 'hsl(26, 100%, 55%)'
      },
      departureTimeLate: {
        icon: 'hsl(207, 98%, 40%)'
      }
    },
    focusRing: {
      shapeStart: 'hsl(0, 0%, 100%)',
      shapeMiddle: 'hsl(254, 70%, 62%)',
      shapeEnd: 'hsl(0, 0%, 100%)'
    },
    menuItem: {
      normal: {
        text: 'hsl(0, 0%, 27%)'
      },
      selected: {
        background: 'hsla(203, 100%, 59%, 0.1)',
        text: 'hsl(207, 98%, 40%)'
      },
      disabled: {
        background: 'hsla(0, 0%, 0%, 0)',
        text: 'hsl(0, 0%, 66%)'
      },
      hover: {
        background: 'hsla(203, 100%, 59%, 0.1)'
      }
    },
    modesOfTransportation: {
      bus: {
        '50': 'hsla(203, 100%, 59%, 0.1)',
        '200': 'hsl(205, 100%, 81%)',
        '400': 'hsl(208, 77%, 52%)',
        '700': 'hsl(210, 100%, 25%)'
      },
      carpool: {
        '50': 'hsla(36, 100%, 56%, 0.1)',
        '200': 'hsl(32, 100%, 79%)',
        '400': 'hsl(28, 100%, 64%)',
        '700': 'hsl(22, 98%, 35%)'
      },
      ferry: {
        '50': 'hsla(200, 100%, 67%, 0.1)',
        '200': 'hsl(196, 100%, 82%)',
        '400': 'hsl(203, 100%, 59%)',
        '700': 'hsl(218, 100%, 42%)'
      },
      shuttle: {
        '50': 'hsla(188, 94%, 46%, 0.1)',
        '200': 'hsl(179, 59%, 78%)',
        '400': 'hsl(183, 60%, 48%)',
        '700': 'hsl(189, 100%, 21%)'
      },
      train: {
        '50': 'hsla(149, 94%, 50%, 0.1)',
        '200': 'hsl(141, 84%, 81%)',
        '400': 'hsl(145, 72%, 57%)',
        '700': 'hsl(151, 82%, 30%)'
      },
      plane: {
        '50': 'hsla(0, 0%, 66%, 0.1)',
        '200': 'hsl(0, 0%, 85%)',
        '400': 'hsl(0, 0%, 74%)',
        '700': 'hsl(0, 0%, 27%)'
      }
    },
    progressBar: {
      primary: {
        track: 'hsla(0, 0%, 42%, 0.1)',
        progress: 'hsl(95, 50%, 44%)'
      },
      secondary: {
        track: 'hsla(0, 0%, 42%, 0.1)',
        progress: 'hsl(147, 71%, 49%)'
      }
    },
    root: {
      background: 'hsl(0, 0%, 100%)'
    },
    stopTime: {
      long: 'hsl(356, 23%, 56%)',
      medium: 'hsl(35, 21%, 53%)',
      short: 'hsl(0, 0%, 57%)'
    },
    tab: {
      text: {
        primary: {
          selected: 'hsl(207, 98%, 40%)',
          disabled: 'hsl(0, 0%, 74%)'
        },
        secondary: {
          selected: 'hsl(207, 98%, 40%)',
          disabled: 'hsl(0, 0%, 74%)'
        }
      },
      border: {
        primary: 'hsl(207, 98%, 40%)',
        secondary: 'hsl(207, 98%, 40%)'
      }
    }
  }
};
var _default = exports.default = colors;